VjsAdmin.Auth2Factor = (function () {
    const init = function () {
        $('#code').focus();
    };

    return {
        init,
    };
}());
